import { atom } from 'jotai';

// Basic modal atoms for V3 - simplified set compared to V2
export const isSecretMenuModalShownAtom = atom<boolean>(false);
export const isWinnerColumnsModalShownAtom = atom<boolean>(false);
